import { Box, Skeleton } from '@mui/material';
import { styled } from '@mui/system';

import { CLASS_LOGO_PATH } from '../../config/apiPaths';
import { ImageWrapper, Title, TitleText } from '../Login/LoginPage';

const Container = styled(Box)`
    padding: 6rem 4rem;
    max-width: 450px;
    margin: 0 auto;
`;

const FormLoading = styled(Skeleton)`
    width: 100%;
    height: 41px;
    margin-bottom: 1.5rem;
    transform: none;
`;

const Spacer = styled(Box)`
    margin-bottom: 24px;
`;

const SignUpPageLoading = () => (
    <Container>
        <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
        <Title>
            <TitleText>
                <Skeleton width={250} />
            </TitleText>
        </Title>
        <Spacer />
        <FormLoading />
        <FormLoading />
        <FormLoading />
    </Container>
);

export default SignUpPageLoading;
